import React from "react";
import styled from "styled-components";
import { LucideIcon } from "lucide-react";

import { Color } from "../../../constants/color";

// Lo stato vuoto delle tre tab di ricerca: senza di lui un risultato vuoto
// lasciava la pagina bianca, con la sola riga di intestazione sopra il nulla.
// La card ripete la forma degli accordion della lista (bianca, arrotondata,
// stessa ombra), così il vuoto si legge come un risultato e non come una
// schermata rotta.
const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* La card si tiene la larghezza del proprio contenuto anche quando il
     contenitore della lista non centra i figli (tab Scadenza), dove lo
     stiramento predefinito la faceva larga quanto la tabella. */
  align-self: center;
  gap: 0.5rem;
  margin-top: 4rem;
  padding: 2.5rem 3rem;
  border-radius: 1rem;
  background-color: ${Color.WHITE};
  text-align: center;
  filter: drop-shadow(4px -4px 5px var(--shadow800));

  & p.titolo {
    font-size: 1.5rem;
    font-weight: bold;
    color: ${Color.LIGHT_BLUE};
  }

  & p.suggerimento {
    font-size: 1rem;
    max-width: 44ch;
  }
`;

// Il suggerimento distingue i due vuoti possibili, che per chi guarda sono
// due problemi diversi: i filtri escludono tutto, oppure non c'è ancora
// nulla da mostrare. Il chiamante sceglie titolo e suggerimento perché le
// tre tab elencano cose diverse (dipendenti, corsi, attestati).
export function StatoVuoto({
  icona: Icona,
  titolo,
  suggerimento,
}: {
  icona: LucideIcon;
  titolo: string;
  suggerimento: string;
}) {
  return (
    <Card>
      <Icona color={Color.LIGHT_BLUE} size={48} strokeWidth={1.2} />
      <p className="titolo">{titolo}</p>
      <p className="suggerimento">{suggerimento}</p>
    </Card>
  );
}
